import { useEffect } from "react"
import { useLocalization } from "@tm/localization"
import { channel } from "@tm/models"
import { useWorkTask } from "@tm/context-distribution"
import { useSnackbar } from "@portal/components/Snackbar"
import { getBundleParams } from "../../utils"

export default function ArticleAddedMessageComponent() {
    const { translateText } = useLocalization()
    const { hideAddArticlesToBasketOrCostEstimationToastMessage } = getBundleParams()
    const workTaskId = useWorkTask()?.workTaskId
    const { addMessage } = useSnackbar()

    useEffect(() => {
        if (hideAddArticlesToBasketOrCostEstimationToastMessage) {
            return
        }

        const unsubscriptions: Array<() => void> = []

        const worktaskChannel = channel("WORKTASK", workTaskId)
        unsubscriptions.push(
            worktaskChannel.subscribe("BASKET/ARTICLE_ADDED", () => {
                addMessage(translateText(1728), "success")
            })
        )
        unsubscriptions.push(
            worktaskChannel.subscribe("BASKET/ARTICLE_QUANTITY_CHANGED", () => {
                addMessage(translateText(1729), "success")
            })
        )

        return () => {
            unsubscriptions.forEach((unsub) => unsub())
        }
    }, [hideAddArticlesToBasketOrCostEstimationToastMessage, workTaskId, addMessage, translateText])

    return null
}
